const PIXEL_SIZE = 20

export enum MimeType {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export const pixelateImage = async (
  src: string,
  mimeType: MimeType = MimeType.PNG,
  pixelSize = PIXEL_SIZE,
): Promise<string | undefined> => {
  return new Promise((resolve) => {
    const img = new Image()

    img.src = src + '?' + new Date().getTime()
    img.setAttribute('crossOrigin', '')

    img.addEventListener('load', () => {
      const width = img.width
      const height = img.height
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D

      ctx.drawImage(img, 0, 0)
      const pixelArr = ctx.getImageData(0, 0, width, height).data
      for (let y = 0; y < height; y += pixelSize) {
        for (let x = 0; x < width; x += pixelSize) {
          const p = (x + y * width) * 4
          ctx.fillStyle = `rgba(${pixelArr[p]},${pixelArr[p + 1]},${pixelArr[p + 2]},${pixelArr[p + 3]})`
          ctx.fillRect(x, y, pixelSize, pixelSize)
        }
      }

      if (mimeType === MimeType.JPEG) {
        resolve(canvas.toDataURL(mimeType))
      }

      resolve(canvas.toDataURL())
    })

    img.addEventListener('error', () => {
      resolve(undefined)
    })
  })
}
